/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hplc_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why scale a method between columns?`)
};

const es_hplc_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué escalar un método entre columnas?`)
};

const de_hplc_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum eine Methode zwischen Säulen skalieren?`)
};

const nl_hplc_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom een methode tussen kolommen schalen?`)
};

const fr_hplc_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi adapter une méthode entre colonnes ?`)
};

const it_hplc_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché scalare un metodo tra colonne?`)
};

const pt_br2_hplc_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que dimensionar um método entre colunas?`)
};

const pt_hplc_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porquê escalar um método entre colunas?`)
};

const ja_hplc_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`なぜカラム間でメソッドをスケーリングするのですか?`)
};

const zh_hplc_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么要在色谱柱之间按比例转移方法？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hplc_faq_q1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hplc_faq_q1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hplc_faq_q1", locale)
	if (locale === "en") return en_hplc_faq_q1(inputs)
	if (locale === "es") return es_hplc_faq_q1(inputs)
	if (locale === "de") return de_hplc_faq_q1(inputs)
	if (locale === "nl") return nl_hplc_faq_q1(inputs)
	if (locale === "fr") return fr_hplc_faq_q1(inputs)
	if (locale === "it") return it_hplc_faq_q1(inputs)
	if (locale === "pt-BR") return pt_br2_hplc_faq_q1(inputs)
	if (locale === "pt") return pt_hplc_faq_q1(inputs)
	if (locale === "ja") return ja_hplc_faq_q1(inputs)
	return zh_hplc_faq_q1(inputs)
};